import { render, staticRenderFns } from "./dashboardReportItem.vue?vue&type=template&id=1626cbea&scoped=true&"
import script from "./dashboardReportItem.vue?vue&type=script&lang=js&"
export * from "./dashboardReportItem.vue?vue&type=script&lang=js&"
import style0 from "./dashboardReportItem.vue?vue&type=style&index=0&id=1626cbea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1626cbea",
  null
  
)

export default component.exports